// MetricsTable.js
import React, { useContext } from 'react';
import definitions from "../constants/metricsDefinitions";
import InfoTooltip from "./InfoTooltip";
import './MetricsTable.css'; 
import { FaRegStar, FaStar } from 'react-icons/fa';
import { WatchlistContext } from '../contexts/StockWatchlistContext';
import { METRIC_FIELDS as metricFields } from "../constants/metricFields";


const MetricsTable = ({ metricsData, filteredSymbols }) => {
  const { symbols: watchlistStocks, add: addToWatchlist, remove: removeFromWatchlist } = useContext(WatchlistContext);

  const handleStarClick = (symbol) => {
    if (watchlistStocks.includes(symbol)) {
      removeFromWatchlist(symbol);
    } else {
      addToWatchlist(symbol);
    }
  };

//   Why the metrics are stuctured below and why this is better:
// It mirrors an investor’s thought process:
// 1. Can it survive (liquidity)?
// 2. Is it profitable?
// 3. Is it efficient with capital?
// 4. What's the free cash flow like
// 5. Is it overleveraged?
// 6. Is it expensive?

// const metricFields = [
//   // 1. Liquidity – can the company cover its short-term obligations?
//   { label: "Current Ratio", value: "currentRatio" },
//   { label: "Quick Ratio", value: "quickRatio" },

//   // 2. Profitability – how efficient is the company at generating profits?
//   { label: "Gross Profit Margin", value: "grossProfitMargin" },
//   { label: "Operating Profit Margin", value: "operatingProfitMargin" },
//   { label: "Net Profit Margin", value: "netProfitMargin" },

//   // 3. Returns – how well is it rewarding investors?
//   { label: "Return on Assets", value: "returnOnAssets" },
//   { label: "Return on Equity", value: "returnOnEquity" },

//   // 4. Leverage – how risky is the capital structure?
//   { label: "Debt to Equity Ratio", value: "debtEquityRatio" },

//   // 5. Cash Flow – how strong is free cash flow generation?
//   { label: "Free Cash Flow per Share", value: "freeCashFlowPerShare" },
//   { label: "FCF / Operating Cash Flow Ratio", value: "freeCashFlowOperatingCashFlowRatio" },

//   // 6. Valuation – how is the market pricing the stock?
//   { label: "Price to Earnings Ratio", value: "priceToEarningsRatio" },
//   { label: "Price to Sales Ratio", value: "priceToSalesRatio" },
//   { label: "Price to Free Cash Flow Ratio", value: "priceToFreeCashFlowsRatio" }
// ];


  return (
    <div className="table-container">
      <div className="table-scroll">
      <table className="metrics-table">
        <thead>
          <tr>
            <th>Metric</th>
            {filteredSymbols.map(symbol => (
              <th key={symbol}>
                {symbol}{' '}
                <span 
                  className="watchlist-star" 
                  onClick={(e) => {
                    e.stopPropagation();
                    handleStarClick(symbol);
                  }}
                >
                  {watchlistStocks.includes(symbol) 
                    ? <FaStar className="star-filled" /> 
                    : <FaRegStar className="star-outline" />}
                </span>
              </th>
            ))}
            <th />  {/* empty header for info icon column */}
          </tr>
        </thead>
        <tbody>

        {metricFields.map(({ label, value }) => {
          const def = definitions[value] || "No description";
          return (
            <tr key={value}>
              <td className="metric-name">
              {label}
              
              </td>


              {filteredSymbols.map(symbol => (
                <td key={`${symbol}-${value}`}>
                  {metricsData[symbol] && metricsData[symbol][value] != null 
                    ? metricsData[symbol][value].toFixed(2) 
                    : "NA"}
                </td>
              ))}
           
           {/* Info icon cell, far right */}
               <td className="metric-info-cell">
                  <InfoTooltip text={def} />
                </td>

              </tr>
            );
        })}

        </tbody>
      </table>

      </div>
      
    </div>
  );
};

export default MetricsTable;

